// Auto-generated commands for Users domain — DO NOT EDIT.

import type { CommandDef } from '@voicedojo/api';
import type { CueLength } from '../enums.g.js';
import type { RecordingId, UserId } from '../ids.g.js';

export interface AddUserMobileCommand {
  mobile: string;
  id: UserId;
}

export interface CreateAdminUserCommand {
  email: string;
  name?: string;
  id?: UserId;
}

export interface CreateUserCommand {
  name?: string;
  email: string;
  id: UserId;
}

export interface DeactivateUserCommand {
  id: UserId;
}

export interface DiscardMissingObjectRecordingsCommand {
  recordingIds: RecordingId[];
  id: UserId;
}

export interface ProfileUpdateCommand {
  name?: string;
  id: UserId;
}

export interface ReactivateUserCommand {
  id: UserId;
}

export interface RemoveUserRoleCommand {
  role: string;
  id: UserId;
}

export interface RetryPendingPurchasesCommand {
  id: UserId;
}

export interface SetAutoDeleteCommand {
  autoDeleteEnabled: boolean;
  retentionKeepDays: number;
  id: UserId;
}

export interface SetAutoSaveCommand {
  autoSave: boolean;
  id: UserId;
}

export interface SetAvatarCommand {
  avatar: string;
  id: UserId;
}

export interface SetCueLengthCommand {
  cueLength: CueLength;
  id: UserId;
}

export interface SetPracticeRemindersCommand {
  enabled: boolean;
  id: UserId;
}

export interface SetPreferredWpmCommand {
  preferredWpm: number;
  id: UserId;
}

export interface SetUserCultureCommand {
  culture: string;
  id: UserId;
}

export interface SetUserRolesCommand {
  roles: string[];
  id: UserId;
}

export interface SetUserTimeZoneCommand {
  timeZone: string;
  detected?: boolean;
  id: UserId;
}

export interface StartImpersonationCommand {
  targetUserId: UserId;
  reason: string;
  id: UserId;
}

export interface StopImpersonationCommand {
  id: UserId;
}

export interface UpdateRecordingSettingsCommand {
  defaultRecordingQuality: string;
  id: UserId;
}

/** CommandDef descriptor for POST /api/command ($type: 'AddUserMobileCommand'). */
export const addUserMobile: CommandDef<AddUserMobileCommand> = {
  $type: 'AddUserMobileCommand',
};

/** CommandDef descriptor for POST /api/command ($type: 'CreateAdminUserCommand'). */
export const createAdminUser: CommandDef<CreateAdminUserCommand> = {
  $type: 'CreateAdminUserCommand',
};

/** CommandDef descriptor for POST /api/command ($type: 'CreateUserCommand'). */
export const createUser: CommandDef<CreateUserCommand> = {
  $type: 'CreateUserCommand',
};

/** CommandDef descriptor for POST /api/command ($type: 'DeactivateUserCommand'). */
export const deactivateUser: CommandDef<DeactivateUserCommand> = {
  $type: 'DeactivateUserCommand',
};

/** CommandDef descriptor for POST /api/command ($type: 'DiscardMissingObjectRecordingsCommand'). */
export const discardMissingObjectRecordings: CommandDef<DiscardMissingObjectRecordingsCommand> = {
  $type: 'DiscardMissingObjectRecordingsCommand',
};

/** CommandDef descriptor for POST /api/command ($type: 'ProfileUpdateCommand'). */
export const profileUpdate: CommandDef<ProfileUpdateCommand> = {
  $type: 'ProfileUpdateCommand',
};

/** CommandDef descriptor for POST /api/command ($type: 'ReactivateUserCommand'). */
export const reactivateUser: CommandDef<ReactivateUserCommand> = {
  $type: 'ReactivateUserCommand',
};

/** CommandDef descriptor for POST /api/command ($type: 'RemoveUserRoleCommand'). */
export const removeUserRole: CommandDef<RemoveUserRoleCommand> = {
  $type: 'RemoveUserRoleCommand',
};

/** CommandDef descriptor for POST /api/command ($type: 'RetryPendingPurchasesCommand'). */
export const retryPendingPurchases: CommandDef<RetryPendingPurchasesCommand> = {
  $type: 'RetryPendingPurchasesCommand',
};

/** CommandDef descriptor for POST /api/command ($type: 'SetAutoDeleteCommand'). */
export const setAutoDelete: CommandDef<SetAutoDeleteCommand> = {
  $type: 'SetAutoDeleteCommand',
};

/** CommandDef descriptor for POST /api/command ($type: 'SetAutoSaveCommand'). */
export const setAutoSave: CommandDef<SetAutoSaveCommand> = {
  $type: 'SetAutoSaveCommand',
};

/** CommandDef descriptor for POST /api/command ($type: 'SetAvatarCommand'). */
export const setAvatar: CommandDef<SetAvatarCommand> = {
  $type: 'SetAvatarCommand',
};

/** CommandDef descriptor for POST /api/command ($type: 'SetCueLengthCommand'). */
export const setCueLength: CommandDef<SetCueLengthCommand> = {
  $type: 'SetCueLengthCommand',
};

/** CommandDef descriptor for POST /api/command ($type: 'SetPracticeRemindersCommand'). */
export const setPracticeReminders: CommandDef<SetPracticeRemindersCommand> = {
  $type: 'SetPracticeRemindersCommand',
};

/** CommandDef descriptor for POST /api/command ($type: 'SetPreferredWpmCommand'). */
export const setPreferredWpm: CommandDef<SetPreferredWpmCommand> = {
  $type: 'SetPreferredWpmCommand',
};

/** CommandDef descriptor for POST /api/command ($type: 'SetUserCultureCommand'). */
export const setUserCulture: CommandDef<SetUserCultureCommand> = {
  $type: 'SetUserCultureCommand',
};

/** CommandDef descriptor for POST /api/command ($type: 'SetUserRolesCommand'). */
export const setUserRoles: CommandDef<SetUserRolesCommand> = {
  $type: 'SetUserRolesCommand',
};

/** CommandDef descriptor for POST /api/command ($type: 'SetUserTimeZoneCommand'). */
export const setUserTimeZone: CommandDef<SetUserTimeZoneCommand> = {
  $type: 'SetUserTimeZoneCommand',
};

/** CommandDef descriptor for POST /api/command ($type: 'StartImpersonationCommand'). */
export const startImpersonation: CommandDef<StartImpersonationCommand> = {
  $type: 'StartImpersonationCommand',
};

/** CommandDef descriptor for POST /api/command ($type: 'StopImpersonationCommand'). */
export const stopImpersonation: CommandDef<StopImpersonationCommand> = {
  $type: 'StopImpersonationCommand',
};

/** CommandDef descriptor for POST /api/command ($type: 'UpdateRecordingSettingsCommand'). */
export const updateRecordingSettings: CommandDef<UpdateRecordingSettingsCommand> = {
  $type: 'UpdateRecordingSettingsCommand',
};

